/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

interface JQueryStatic {
    material: any;
}

class MaterialDirective {
    public scope = false;
    public restrict = 'A';


    public link = () => {
        $.material.options.validate = false;
        $.material.init();
    };

    public static DirectiveFn(): MaterialDirective {
        return new MaterialDirective();
    }
}


angular.module('beneple.global').directive('material', MaterialDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/material.directive.ts